//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowExit(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 21H5V3H3V21ZM17.27 6H14.66L18.86 11H7V13H18.86L14.66 18H17.27L22.27 12L17.27 6Z" fill="currentColor" /></svg>;
}
export default IconArrowExit;